import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_SELECTED_CHARTS } from '../../../utils/constants';
import { CHARTS } from '../constants';
import selectedDesignSlice from '../../../redux/slices/selectedDesignSlice';
import tabbarSlice from '../../Tabbar/tabbarSlice';
import { tabRoutes } from '../../../routes';

const chartsSelectSlice = createSlice({
	name: 'chartsSelect',
	slice: 'chartsSelect',
	initialState: {
		selectedCharts: {
			DESIGN: [],
			SUMMARY: [],
			defaultDESIGN: [],
			defaultSUMMARY: []
		}
	},
	reducers: {
		setSelected(state, action) {
			const { page, charts } = action.payload;
			state.selectedCharts[page] = charts;
		}
	},
	extraReducers: {
		[selectedDesignSlice.actions.setDetail](state, action) {
			const validatedDesignCharts = DEFAULT_SELECTED_CHARTS.filter(selectedChart =>
				action.payload.designDetail.charts.some(chart => chart.chartName === selectedChart)
			);
			const validatedSummaryCharts = Object.keys(CHARTS)
				.filter(chartConstName => action.payload.designDetail.charts.some(chart => chart.chartName === chartConstName))
				.concat('All');

			state.selectedCharts.DESIGN = validatedDesignCharts;
			state.selectedCharts.SUMMARY = validatedSummaryCharts;
			state.selectedCharts.defaultDESIGN = validatedDesignCharts;
			state.selectedCharts.defaultSUMMARY = validatedSummaryCharts;
		},
		[tabbarSlice.actions.activateTab](state, action) {
			if (tabRoutes.find(route => route.tabId === action.payload).path === '/summary') {
				state.selectedCharts.DESIGN = state.selectedCharts.defaultDESIGN;
			}

			if (tabRoutes.find(route => route.tabId === action.payload).name === 'Summary') {
				state.selectedCharts.SUMMARY = state.selectedCharts.defaultSUMMARY;
			}
		}
	}
});

export default chartsSelectSlice;
